// ClienteForm.js (Dentro de src/components/clientes/)

import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const initialClienteData = {
    razonSocial: 'Nombre del Cliente',
    rfc: 'RFCDELCLIENTE123',
    correo: 'contacto@cliente.com',
    telefono: '5551234567'
};

const ClienteForm = (props) => {
    
    const id = props.match?.params?.id; 
    const isEditing = !!id;
    
    const [clienteData, setClienteData] = useState(initialClienteData);
    const [pass, setPass] = useState({ pass: '', new: '', confirm: '' });
    const [errorPass, setErrorPass] = useState(false);
    
    useEffect(() => {
        if (isEditing) {
        }
    }, [id, isEditing]);

    const handleDataChange = (e) => {
        setClienteData({ ...clienteData, [e.target.name]: e.target.value });
    };

    const handlePassChange = (name, value) => {
        setPass(prevPass => ({ ...prevPass, [name]: value }));
    };

    const guardarCliente = () => {
        toast.success(`Cliente ${isEditing ? 'actualizado' : 'creado'} exitosamente.`)
        props.history.push(`${process.env.PUBLIC_URL}/clientes`);
    };

    const setPassword = async () => {
        if (pass.pass.length > 4 && pass.new.length > 4 && pass.confirm.length > 4) {
            setErrorPass(false);
            
            toast.success('Contraseña del cliente cambiada.');
            setPass({ pass: '', new: '', confirm: '' });
        } else {
            setErrorPass(true);
            toast.warn('La contraseña debe tener un mínimo de 5 caracteres.');
        }
    };

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 mt-3">
                        <div className="row">
                            <button className="btn btn-success" style={{ marginLeft: 15 }} 
                                onClick={() => props.history.goBack()}>
                                ATRAS
                            </button>
                            <div className="col-sm-8">
                                <h4 style={{ marginLeft: 15 }}>{isEditing ? `Editar Cliente: ${clienteData.razonSocial}` : 'Nuevo Cliente'}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-xl-12 xl-100">
                        <div className="card height-equal mt-2">
                            <div className="card-body">
                                
                                
                                <h5>Información del Cliente</h5>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Razón Social</label>
                                        <input className="form-control" name="razonSocial" value={clienteData.razonSocial} onChange={handleDataChange} />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">RFC</label>
                                        <input className="form-control" name="rfc" value={clienteData.rfc} onChange={handleDataChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Correo</label>
                                        <input className="form-control" name="correo" value={clienteData.correo} onChange={handleDataChange} />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Teléfono</label>
                                        <input className="form-control" name="telefono" value={clienteData.telefono} onChange={handleDataChange} />
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-sm-12 text-right">
                                        <button className="btn btn-success" onClick={guardarCliente}>
                                            Guardar Cliente
                                        </button>
                                    </div>
                                </div>
                                
                                <hr className="mt-4 mb-4" /> 


                                <h5 className="mb-3">Cambiar Contraseña (Acceso del Cliente)</h5>

                                <div className="row">
                                    
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Contraseña Actual</label>
                                        <input className="form-control" type="password" value={pass.pass} onChange={e => handlePassChange('pass', e.target.value)} />
                                    </div>
                                    
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Nueva Contraseña</label>
                                        <input className="form-control" type="password" value={pass.new} onChange={e => handlePassChange('new', e.target.value)} />
                                        <small className="form-text text-success" style={{ color: '#4CAF50' }}>mínimo 5 caracteres</small>
                                    </div>
                                    
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Confirmar Contraseña</label>
                                        <input className="form-control" type="password" value={pass.confirm} onChange={e => handlePassChange('confirm', e.target.value)} />
                                        <small className="form-text text-success" style={{ color: '#4CAF50' }}>mínimo 5 caracteres</small>
                                    </div>
                                    
                                    <div className="col-sm-12 mt-3">
                                        {errorPass && <a className="text-danger mb-2 d-block text-center">Completa todos los datos de contraseña correctamente (mínimo 5 caracteres).</a>}
                                        <button className="btn btn-primary" onClick={setPassword}>
                                            Reenviar Contraseña
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ClienteForm;